import React from 'react';
import { Screen } from './styles';
import { useParams, useNavigate } from 'react-router-dom';
import ExpiringScreen from './ReportTypes/Expiring';
import SalesScreen from './ReportTypes/Sales';
import StockTakeScreen from './ReportTypes/StockTake';
import StockOnHandScreen from './ReportTypes/StockOnHand';
import RecallScreen from './ReportTypes/Recall';
import StockMovementScreen from './ReportTypes/StockMovement';
import './_styles.reports.scss';

const ReportsScreen = () => {
  const { reportType } = useParams();
  const navigate = useNavigate();

  return (
    <Screen>
      <div className='tabs-screen'>
        <div className='tabs-header'>
          <div
            className={`tab ${
              reportType == 'sales' || !reportType ? 'active' : null
            }`}
            onClick={() => navigate('/reports/sales')}
          >
            Sales
          </div>
          <div
            className={`tab ${reportType == 'stocktake' ? 'active' : null}`}
            onClick={() => navigate('/reports/stocktake')}
          >
            Stock Take
          </div>
          <div
            className={`tab ${reportType == 'stockonhand' ? 'active' : null}`}
            onClick={() => navigate('/reports/stockonhand')}
          >
            Stock On Hand
          </div>
          <div
            className={`tab ${reportType == 'expiring' ? 'active' : null}`}
            onClick={() => navigate('/reports/expiring')}
          >
            Expiring
          </div>
          <div
            className={`tab ${reportType == 'recall' ? 'active' : null}`}
            onClick={() => navigate('/reports/recall')}
          >
            Recall
          </div>
          <div
            className={`tab ${reportType == 'movement' ? 'active' : null}`}
            onClick={() => navigate('/reports/movement')}
          >
            Stock Movement
          </div>
        </div>
        {(reportType === 'sales' || !reportType) && <SalesScreen />}
        {reportType === 'stocktake' && <StockTakeScreen />}
        {reportType === 'stockonhand' && <StockOnHandScreen />}
        {reportType === 'expiring' && <ExpiringScreen />}
        {reportType === 'recall' && <RecallScreen />}
        {reportType === 'movement' && <StockMovementScreen />}
      </div>
    </Screen>
  );
};

export default ReportsScreen;
